import { getLoggedInUser, setSession } from "./authUtils";
import axios from "axios";

const getAxiosConfig = () => ({
  headers: {
    Authorization: `${(getLoggedInUser() || {}).token}`,
    'Cache-Control': 'no-cache',
  }  
});

const iOS = () => {
  const isChrome = /Chrome/.test(navigator.userAgent)
  const is_OSX = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  const is_iOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);

  const is_Mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const is_iPhone = navigator.platform === "iPhone";
  const is_iPod = navigator.platform === "iPod";
  const is_iPad = navigator.platform === "iPad";
  return (is_OSX && !isChrome) || is_iOS || (is_Mac && !isChrome) || is_iPhone || is_iPod || is_iPad;
}

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  console.debug(JSON.stringify(error));
  if(error.message === 'Request failed with status code 401'){
    setSession(undefined);
    window.location.reload();
  }
  
  return Promise.reject(error);
});

export {
  getAxiosConfig,
  iOS,
  axios,
}